import React, { useEffect, useMemo } from "react";
import { Box, IconButton, Tooltip, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import EditNoteIcon from "@mui/icons-material/EditNote";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useLocation } from "react-router-dom";

const RibbonNavbar = ({
  selectedRows = [],
  onAdd,
  onEdit,
  onView,
  onDelete,
  onApprove,
}) => {
  const user = JSON.parse(localStorage.getItem("loggedUser")) || {};
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  /* 🔐 Resolve module permissions */
  const moduleFunctions = useMemo(() => {
    const currentModuleFunction = user.userRoles
      ?.flatMap((role) => role.functions || [])
      .find(
        (f) => f.uriPath?.toLowerCase() === location.pathname.toLowerCase()
      );

    const moduleName = currentModuleFunction?.modules?.name;

    return (
      user.userRoles
        ?.flatMap((role) => role.functions || [])
        .filter((f) => f.modules?.name === moduleName) || []
    );
  }, [user, location.pathname]);

  const canAdd = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "CREATE")
  );
  const canEdit = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "UPDATE")
  );
  const canView = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "READ")
  );
  const canDelete = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "DELETE")
  );
  const canApprove = moduleFunctions.some((f) =>
    f.actions?.some((a) => a.name === "APPROVE")
  );

  useEffect(() => {
    console.log("Selected Rows:", selectedRows);
  }, [selectedRows]);

  const iconStyle = {
    color: "#042d8c",
    borderRadius: "12px",
    padding: isMobile ? "6px" : "8px",
    "&:hover": { transform: "scale(1.15)" },
  };

  const ribbonStyle = (color) => ({
  color: color,
  borderRadius: "10px",
  transition: "all 0.25s ease",
  
  "&:hover": {
    backgroundColor: color,     // 👈 solid shade on hover
    color: "#fff",              // icon turns white
    transform: "translateY(-3px)",
    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
  },

  "&.Mui-disabled": {
    color: "#b0bec5",
  },
});

  return (
    <Box
      sx={{
        display: "flex",
        gap: isMobile ? 1.5 : 2,
        alignItems: "center",
        flexWrap: "wrap",
        px: 2,
        py: 1,
        borderRadius: 2,
        // backgroundColor: "#f8fafc",
        // border: "1px solid #e0e6ed",
      }}
    >
      {/* ADD */}
      {/* {canAdd && ( */}
        <Tooltip title="Add" arrow>
          <span>
            <IconButton
              onClick={onAdd}
              sx={ribbonStyle("#2e7d32")}
            >
              <AddCircleOutlineIcon fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
          </span>
        </Tooltip>
      {/* )} */}

      {/* EDIT */}
      {canEdit && (
        <Tooltip title="Edit" arrow>
          <span>
            <IconButton
              onClick={onEdit}
              disabled={selectedRows.length !== 1}
              sx={ribbonStyle("#1565c0")}
            >
              <EditNoteIcon fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
          </span>
        </Tooltip>
      )}

      {/* VIEW */}
      {/* {canView && ( */}
        <Tooltip title="View" arrow>
          <span>
            <IconButton
              onClick={onView}
              disabled={selectedRows.length === 0}
              sx={ribbonStyle("#6a1b9a")}
            >
              <PreviewIcon fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
          </span>
        </Tooltip>
      {/* )} */}

      {/* DELETE */}
      {/* {canDelete && ( */}
        <Tooltip title="Delete" arrow>
          <span>
            <IconButton
              onClick={onDelete}
              disabled={selectedRows.length === 0}
              sx={ribbonStyle("#c62828")}
            >
              <DeleteForeverIcon fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
          </span>
        </Tooltip>
      {/* )} */}

      {/* APPROVE */}
      {/* {canApprove && ( */}
        <Tooltip title="Approve" arrow>
          <span>
            <IconButton
              onClick={onApprove}
              disabled={selectedRows.length === 0}
              sx={ribbonStyle("#00897b")}
            >
              <CheckCircleIcon fontSize={isMobile ? "small" : "medium"} />
            </IconButton>
          </span>
        </Tooltip>
      {/* )} */}
    </Box>
  );
};

export default RibbonNavbar;
